<template>
  <div id="app">
    <router-view v-if="!$route.meta.keepAlive" style="height: 100%;"/>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" style="height: 100%;"/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  height: 100%;
  margin: 0;
  width: 100vw;
}

</style>



// WEBPACK FOOTER //
// src/App.vue